type JsonObject = Record<string, unknown>

const objectValue = (value: unknown): JsonObject =>
  value && typeof value === "object" && !Array.isArray(value) ? (value as JsonObject) : {}

const textValue = (value: unknown): string => (typeof value === "string" ? value.trim() : "")

/** Read accepted contacts from durable results, never from the original suggestion. */
export const acceptedContactValues = (output: unknown): { email: string; phone: string } => {
  const decisions = objectValue(output).decisions
  const values = { email: "", phone: "" }

  for (const raw of Array.isArray(decisions) ? decisions : []) {
    const decision = objectValue(raw)

    if (!["ACCEPT_CONTACT_POINT", "REPLACE_CONTACT_POINT"].includes(textValue(decision.action)))
      continue

    const snapshot = objectValue(
      decision.action === "REPLACE_CONTACT_POINT"
        ? decision.replacement_contact_point_snapshot
        : decision.affected_contact_point_snapshot,
    )
    const kind = textValue(snapshot.kind ?? decision.kind)
    const value = textValue(snapshot.value ?? decision.value)

    if (kind === "EMAIL" && !values.email) values.email = value

    if (["MOBILE", "FIXED_LINE"].includes(kind) && !values.phone) values.phone = value
  }

  return values
}
